import { gql } from "@apollo/client";

export const FILL_BLANK_FIELDS = gql`
  fragment FILL_BLANK_FIELDS on fill_blank {
    id
    title
  }
`;
